RivalIQ.apps.AccountSettings.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const ExportDropdown = Marionette.ItemView.extend({
        template: '#receiptExportDropdown',
        className: 'dropdown hidden-xs x-export-hide',

        events: {
            'click .x-download-report': 'onDownload'
        },

        serializeData: function () {
            const me = this;

            const exportItems = me.model.getExportFormats();

            return {
                btnClass: me.getOption('btnClass'),
                exportItems: exportItems
            };
        },

        onDownload: function (e) {
            const me = this;
            const format = $(e.currentTarget).data('format');
            RivalIQ.export.download(format, me.model);
        }
    });

    const DetailsLayout = Dashboard.views.DetailsLayout.extend({
        loadData: function () {
            const me = this;
            return RivalIQ.data.invoices.fetch()
                .then(function (receipts) {
                    me.receipts = receipts;
                    me.receipt = receipts.get(me.dashboardModel.getProp('actionTypeId'));
                });
        },

        onRenderLoaded: function () {
            const me = this;
            me.showLeftToolbarActions();
            me.showToolbarActions();
        },

        getBodyView: function () {
            const me = this;
            return me.dashboardModel.panelView;
        },

        showLeftToolbarActions: function () {
            const me = this;

            me.leftActions.empty();
            if (_.size(me.receipts)) {
                me.leftActions.show(new App.views.InvoiceDateSelect({
                    model: me.receipt,
                    collection: me.receipts
                }), {
                    preventDestroy: true
                });
            }
        },

        showToolbarActions: function () {
            const me = this;

            me.actions.empty();

            if (_.size(me.receipts) > 0) {
                me.actions.show(new RivalIQ.views.Link({
                    className: 'btn btn-default',
                    linkName: 'Edit Receipt Settings',
                    action: function () {
                        RivalIQ.execute('show:modal', new App.views.InvoiceSettings({
                            model: RivalIQ.state.account
                        }));
                    }
                }), {
                    preventDestroy: true
                });
                me.showExportDropdown();
            }
        },

        showExportDropdown: function () {
            const me = this;

            me.actions.show(new ExportDropdown({
                model: me.dashboardModel
            }), {
                preventDestroy: true
            });
        }
    });

    const PanelView = Dashboard.views.Panel.extend({
        template: '#receiptsPanelTemplate',

        onRender: function () {
            const me = this;
            if (!me._isShown) {
                me.showBody();
            }

            me.listenTo(RivalIQ.state.account, 'change', me.showBody);
        }
    });

    const Widget = widgets.Receipts = Dashboard.models.Widget.extend({
        view: App.views.Invoices,
        detailPanelView: DetailsLayout,

        panelView: PanelView,

        viewMore: false,

        getExportOrientation: _.constant(RivalIQ.enums.orientation.PORTRAIT),

        exportFormats: [
            RivalIQ.enums.exportFormat.PDF
        ],

        getExportPathObject: function (format, overrides) {
            const me = this;

            return me.curation.getExportPathObject(format, me.getExportParameters(format, overrides));
        },

        getFilename: function () {
            const me = this;
            return `rivaliq_receipt_${me.getProp('actionTypeId')}`;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.RECEIPTS, Widget);
});
